import {
  IHelpfulReviewPayload,
  IHelpfulReviewResponse,
  IPostReviewResponse,
  IReviewPayload, IReviewsInfo,
} from "api/interfaces/product-review.type";
import axios from "fetch-api/fetch-api";

export function submitReview(review: IReviewPayload) {
  return axios.post<IPostReviewResponse>("/submit-product-review-v4", review);
}

export function getReviews(sku: string, pageNumber: number, pageSize: number, sortBy: string) {
  return axios.get<IReviewsInfo>(`/get-product-reviews-v5?sku=${sku}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}`);
}

export function submitHelpfulReview(data: IHelpfulReviewPayload) {
  return axios.post<IHelpfulReviewResponse>("/update-product-review-helpful-info", data);
}

export function uploadReviewImage(data: FormData) {
  return axios.formData("/upload-review-image", data);
}
